import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";



function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Carousel autoPlay infiniteLoop showThumbs={false} autoFocus={true} showStatus={false} showIndicators={false}>
        {props.crousel?.map((item, i) => (
          <Card.Img key={i} src={item} alt="card-img" />
        ))}
      </Carousel>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify", fontSize: "13px" }}>
          {props.description}
        </Card.Text>

        <div><h5>Tech Stacks</h5></div>

        <div className="tech__Stack__div">
          {props?.techStack?.map((item, i) => (
            <span key={i} className="tech__stack">{item}</span>
          ))}
        </div>

        <Card.Text style={{ textAlign: "justify", fontSize: "13px" }}>
          {props.projectType}
        </Card.Text>

        <div className="project__link__button">
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            GitHub
          </Button>

          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
          >
            <CgWebsite /> &nbsp;
            Demo
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
